import { useRef } from 'react';
import 'chart.js/auto';
import { Chart, getDatasetAtEvent, getElementAtEvent } from 'react-chartjs-2';
import { dateFormat } from '../../classes/utils';
export default function Linechart({ projectScans, setSelectedScan }) {
    const chartRef = useRef()
    const maxVuln = Math.max(...projectScans.map((scan) => scan.vulnerabilityCount))
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        onHover: (event, chart) => {
            setCurserPointerOnHover(event, chart.length)

        },
        scales: {
            y: {
                suggestedMin: 0,
                suggestedMax: 100,
                title: {
                    display: true,
                    text: "Security score",
                    font: {
                        size: 16
                    },
                    color: window.getColor("high"),
                    padding: 5
                },
                // grid: {
                //     color: "#FF6384"
                // }
            },
            vulnerabilityScale: {
                position: "right",
                suggestedMin: 0,
                suggestedMax: maxVuln + 1,
                title: {
                    display: true,
                    text: "Vulnerability count",
                    font: {
                        size: 16
                    },
                    color: window.getColor("low"),
                    padding: 5
                },
                // grid: {
                //     color: "#36A2EB"
                // }
            },
            x: {
                title: {
                    display: true,
                    text: "Date scanned",
                    font: {
                        size: 16
                    },
                    padding: 5
                }
            }
        },
        plugins: {
            tooltip: {
                callbacks: {
                    beforeTitle: (context) => {
                        return "---------------------Analysis---------------------"
                    },
                    title: (context) => {
                        return "Scanned on " + context[0].label
                    },
                    // beforeBody: (context) => {
                    //     return "-----------"
                    // },
                    label: (context) => {
                        const dataVal = context.dataset.data[context.dataIndex]
                        const label = context.dataset.label
                        return ` ${label}: ${dataVal}`
                        if(label === "Security score") {
                        }
                        // return `${label}: ${deNormalizeNumInRange(dataVal, [0, maxVuln], [0, 100])}`
                    },

                    footer: (context) => {
                        try {
                            const mitigationCount = context[0].dataset.mitigationCount[context[0].dataIndex]
                            return mitigationCount !== 0 ? `Fixed ${mitigationCount} vulnerabilities`: "no mitigation"

                        } catch (e) {
                            console.log(e)

                        }
                    }

                }
            }
        },
        elements: {
            point: {
                radius: 5
            }
        }
    }
    const setCurserPointerOnHover = (event, isOnhover) => {
        if(isOnhover) {
            event.native.target.style.cursor = "pointer"

        } else {
            event.native.target.style.cursor = "default"
        }
    }
    const clickHandler = (e) => {
        const clickedDataElement = getElementAtEvent(chartRef.current, e)
        if(clickedDataElement.length) {
            const { index } = getElementAtEvent(chartRef.current, e)[0]
            setSelectedScan(projectScans[index])
        }
    }
    const chartData = {
        labels: projectScans.map((scan) => dateFormat(scan.timestamp)),
        datasets: [
            {         
                label: "Vulnerabilities",
                data: projectScans.map((scan) => scan.vulnerabilityCount ),
                mitigationCount: projectScans.map((scan) => scan.mitigationCount),
                yAxisID: "vulnerabilityScale",
                borderColor: window.getColor("low-half"),
                backgroundColor: window.getColor("low-half"),


            },
            {
                label: "Security score",
                data: projectScans.map((scan) => scan.securityScore),
                mitigationCount: projectScans.map((scan) => scan.mitigationCount),
                yAxisID: "y",
                borderColor: window.getColor("high-half"),
                backgroundColor: window.getColor("high-half"),
            }
        ]
    }
    const plugin = {
        id: "increase-legend-spacing", 
        beforeInit(chart) {
          // reference to the original fit function
          const originalFit = chart.legend.fit;
      
          // Override the fit function
          chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)();
            // Change the height
            this.height += 10;
          }
        }
      }; 
      
    return <Chart ref={chartRef} onClick={clickHandler} type='line' data={chartData} options={options} plugins={[plugin]}/>
}